__turbopack_context__.v({
  "ArticlesListGrid": "Y-t7KW_ArticlesListGrid",
  "ArticlesListItems": "Y-t7KW_ArticlesListItems",
  "ArticlesListPage": "Y-t7KW_ArticlesListPage",
  "ArticlesListWrapper": "Y-t7KW_ArticlesListWrapper",
  "BlueGreen": "Y-t7KW_BlueGreen",
  "ButtonContainer": "Y-t7KW_ButtonContainer",
  "ButtonText": "Y-t7KW_ButtonText",
  "Content": "Y-t7KW_Content",
  "Double": "Y-t7KW_Double",
  "EnoughItems": "Y-t7KW_EnoughItems",
  "FirstItem": "Y-t7KW_FirstItem",
  "Image": "Y-t7KW_Image",
  "ImageContainer": "Y-t7KW_ImageContainer",
  "Item": "Y-t7KW_Item",
  "ItemContainer": "Y-t7KW_ItemContainer",
  "ItemText": "Y-t7KW_ItemText",
  "ItemTitle": "Y-t7KW_ItemTitle",
  "LastItem": "Y-t7KW_LastItem",
  "NotEnoughItems": "Y-t7KW_NotEnoughItems",
  "PinkBlue": "Y-t7KW_PinkBlue",
  "PinkOrange": "Y-t7KW_PinkOrange",
  "PinkPurple": "Y-t7KW_PinkPurple",
  "ReportPage": "Y-t7KW_ReportPage",
  "RichTextPage": "Y-t7KW_RichTextPage",
  "Root": "Y-t7KW_Root",
  "Single": "Y-t7KW_Single",
  "SliderContainer": "Y-t7KW_SliderContainer",
  "ThreeItems": "Y-t7KW_ThreeItems",
  "Title": "Y-t7KW_Title",
  "TitleBottom": "Y-t7KW_TitleBottom",
  "TitleContainer": "Y-t7KW_TitleContainer",
  "TitleDesktop": "Y-t7KW_TitleDesktop",
  "TitleMobile": "Y-t7KW_TitleMobile",
  "TitleTop": "Y-t7KW_TitleTop",
  "Triple": "Y-t7KW_Triple",
  "Visible": "Y-t7KW_Visible",
});
